import React from 'react'

const KristaProjectIntroduction = () => {
  return (
    <>
        <section id="first" className="about bg2">
  <div className="container">
    <div className="section-title">
      <br />
      <h2 className="animated fadeInDown">Introduction</h2>
      <div className="bar" />
      <div className="row">
        <div className="col-lg-12">
          <div className=" cd-intro-content bouncy shadow p-4 animated swing">
            <div className="row">
              <div className="col-md-12">
                <h3 className="text-left mesee-mg animated fadeInUp ease-out-circ d2 a-1 f2 fw3 heading">
                  Krista Mashore
                </h3>
                <p className="text-justify">
                  Krista Mashore Coaching is an application that is basically a
                  coaching app for all the students with the feature Pomodoro
                  Technique involvement for the completion of Tasks as per day
                  wise.The Pomodoro Technique is a productivity system that
                  helps you take the right number of breaks while still getting
                  your work done. Traditionally, it breaks up your day into
                  25-minute focus sessions followed by five-minute breaks.
                </p>
                <p className="text-justify">
                  {" "}
                  It's the perfect length of time for soaking up knowledge and
                  getting things done—without burning out. A dedicated Pomodoro
                  app removes the need to divide up your day manually—instead,
                  it tells you exactly when to work and when to take a short
                  break. Here's a brief look at how the technique works, along
                  with our picks for the 10 best Pomodoro timer apps.
                </p>
              </div>
              {/* <div className="col-lg-4 col-md-4">
                <img src="" />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    </>
  )
}

export default KristaProjectIntroduction